import React, { useState, useEffect } from 'react';
import { Skeleton, Tooltip } from '@mui/material';
import CurrencyValueFlex from 'ui-component/CurrencyValueFlex';
import { useSelector } from 'react-redux';
import { SortDescNumberIcon, SortAscNumberIcon, SortDescAlphabeticalIcon, SortAscAlphabeticalIcon } from 'ui-component/custom-icons/icons';
import { PiMicrosoftExcelLogoFill } from 'react-icons/pi';
import ExportPopupModal from './modal/ExportPopupModal';

// ✅ Clear
const OpenSuppliersWidgetComponent = ({ details, isLoading }) => {
    const [data, setData] = useState([])
    const selectedCurrency = useSelector((state) => state.main.selectedCurrency);
    
    const [sortBy, setSortBy] = useState('total')
    const [sortOrder, setSortOrder] = useState('desc')
    const [isLoadingData, setIsLoadingData] = useState(true)
    
    const [showExportModal, setShowExportModal] = useState(false);
    
    useEffect(() => {
        if (details) {
            setData(details);
        }
    }, [details])
    
    useEffect(() => {
            if (!isLoading) {
                setIsLoadingData(true);
            }
            let sorted = [...details];
            if (sortBy === 'name') {
                sorted.sort((a, b) => {
                    const nameA = a.name || '';
                    const nameB = b.name || '';
                    if (sortOrder === 'asc') {
                        return nameA.localeCompare(nameB);
                    } else {
                        return nameB.localeCompare(nameA);
                    }
                });
            } else if (sortBy === 'total') {
                sorted.sort((a, b) => {
                    if (sortOrder === 'asc') {
                        return parseInt(a.total) - parseInt(b.total);
                    } else {
                        return parseInt(b.total) - parseInt(a.total);
                    }
                });
            }
            setData(sorted);
            if (!isLoading) {
                setTimeout(() => {
                    setIsLoadingData(false);
                }, 300);
            }
    }, [sortBy, sortOrder])


    useEffect(() => {
        setIsLoadingData(isLoading)
    }, [isLoading])
    

    const handleClose = () => {
        setShowExportModal(false);
    }


    return (
        <>
            <div className="card" style={{ height: '200px' }}>
                <div className="card-body" style={{ padding: '15px', zIndex: '1000', zIndex: '1' }}>
                    <div className="flex justify-content-between">
                        <div className="text-lg fw-500">
                            Open Suppliers
                        </div>
                        <div className="flex gap-1 absolute" style={{ right: '20px', top: '6px' }}>
                            {
                                isLoading ? (
                                    <div className="" style={{ width: '100px', marginTop: '8px' }}>
                                        <Skeleton variant="rounded" width={'100%'} height={20} className={`rounded-full`} style={{ borderRadius: '32px' }} />
                                    </div>
                                ) : (
                                    <>
                                        <div
                                            className="widget-action-icon-container"
                                            onClick={() => {
                                                setShowExportModal(true)
                                                // download();
                                            }}
                                        >
                                            <Tooltip title="Export" arrow placement="top">

                                                <div
                                                    href="javascript:void(0);" 
                                                    className="text-black cursor-pointer"
                                                >

                                                    <PiMicrosoftExcelLogoFill style={{ fontSize: '1.4em' }} /> 
                                                </div>
                                            </Tooltip>
                                        </div>
                                        <div
                                            className={`widget-action-icon-container-2 ${sortBy === 'name' ? 'active' : '' }`}
                                            onClick={() => {
                                                setSortBy('name')
                                                setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
                                            }}
                                        >
                                            <Tooltip title="Sort by Name" arrow placement="top">

                                                <div
                                                    href="javascript:void(0);" 
                                                    className="widget-action-icon cursor-pointer"
                                                >
                                                    {
                                                        sortBy === 'name' ? (
                                                            sortOrder === 'asc' ? (
                                                                <SortAscAlphabeticalIcon height='15px' width='15px' />
                                                            ) : (
                                                                <SortDescAlphabeticalIcon height='15px' width='15px' />
                                                            )
                                                        ) : (
                                                            <SortDescAlphabeticalIcon height='15px' width='15px' />
                                                        )
                                                    }
                                                </div>
                                            </Tooltip>
                                        </div>
                                        <div
                                            className={`widget-action-icon-container-2 ${sortBy === 'total' ? 'active' : '' }`}
                                            onClick={() => {
                                                setSortBy('total')
                                                setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
                                            }}
                                        >
                                            <Tooltip title="Sort by Total" arrow placement="top">
                                                <div
                                                    href="javascript:void(0);" 
                                                    className="widget-action-icon cursor-pointer"
                                                >

                                                    {
                                                        sortBy === 'name' ? (
                                                            <SortDescNumberIcon height='15px' width='15px' />
                                                        ) : (
                                                            sortOrder === 'asc' ? (
                                                                <SortAscNumberIcon height='15px' width='15px' />
                                                            ) : (
                                                                <SortDescNumberIcon height='15px' width='15px' />
                                                            )
                                                        )
                                                    }
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </>
                                )
                            }
                        </div>
                    </div>
                    <div className="overflow-y-auto custom-scrollbar" style={{ maxHeight: '135px', margin: '10px 0' }}>
                        {
                            // isLoading ? (
                            (!isLoading && !isLoadingData) ? (
                                data?.length > 0 ? (
                                    data?.map((item, index) => (
                                        item?.total > 0 && (
                                            <div key={index} className="w-full flex justify-between" style={{ padding: '2px 0' }}>
                                                <div className="font-normal" style={{ width: '55%' }}>
                                                    {item?.name}
                                                </div>
                                                <div className="ml-auto text-right" style={{ marginRight: '10px', width: '45%' }}>
                                                    <CurrencyValueFlex
                                                        currencyObject={item?.converted_prices}
                                                        defaultCurrency={selectedCurrency.replace(/\s+/g, '') === 'all' ? 'usd' : selectedCurrency.replace(/\s+/g, '')}
                                                        flex={true}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    ))
                                ) : (
                                    <div className="row" style={{ padding: '5px 0' }}>
                                        <div className="col-12 text-gray-500">
                                            No data found        
                                        </div>
                                    </div>
                                )
                            ) : (
                                [...Array(15)].map((e, i) => (
                                    <div key={i} className="row" style={{ padding: '5px 0' }}>
                                        <div className="col-12">
                                            <Skeleton variant="rounded" width={'100%'} height={15} className={`rounded-full`} style={{ borderRadius: '32px' }} />
                                        </div>
                                    </div>
                                ))
                            )
                        }

                    </div>
                </div>
            </div>

            {
                showExportModal && (
                    <ExportPopupModal
                        isOpen={true}
                        onClose={handleClose}
                        widgetType={'OPEN-SUPPLIERS'}
                        widgetName={'Open Suppliers'}
                    />
                )
            }
        </>
    )
}


export default OpenSuppliersWidgetComponent;